import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className}`}
        >
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-filters-count">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar({ lableFor }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        event.preventDefault()
        setSort(event.target.getAttribute("sortValue"))
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    useEffect(() => {
        if(window.innerWidth > 768){
            document.querySelector("label.ns-act-btn[for='toggle-mobile-sidebar']")?.click();
        }
    })

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-row align-center ns-justify-content-between ns-w-100"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )} */}
                <ToggleMobileSidebarButton
                    lableFor={lableFor}
                    selectedFiltersCount={selectedFiltersCount}
                />
                <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                />

        </div>
    )
}
